export default __webpack_public_path__ + "assets/images/c68d9fa1f1aec6232bf8d00010750afe.svg";